
import Vue from 'vue'
import router from '@/router'
import VueAnalytics from 'vue-analytics'
import VueFb from '@/plugins/VueFb'

export const enableAnalytics = () => {

    console.log('enabling analytics')

    Vue.use(VueAnalytics, {
        id: 'UA-15229379-19',
        router,
        ignoreRoutes: ['tunel'],
        debug: {
            sendHitTask: process.env.NODE_ENV === 'production',
            enabled: false,
        }
    })

    Vue.use(VueFb, {
        appId: '256569492091309',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v7.0'
    })

}